// ABOUTME: Builds support ticket linked-item payloads from loaded objects (order, inbound, return, ...).
// ABOUTME: Reference and name mirror the global search results so links look the same however they were made.

import { support_ticket_linked_type } from './staticEnums';

const asText = (value) => (value !== null && value !== undefined ? String(value) : null);

const buildLinkedItem = (linkedType, item, displayReference, displayName) => {
    if (!item) return null;
    return {
        linkedType,
        linkedId: item.id,
        displayReference: asText(displayReference),
        displayName: asText(displayName),
    };
};

export const linkedItemFromOrder = (order) =>
    buildLinkedItem(support_ticket_linked_type.ORDER, order, order?.barcode, order?.webshopreference);

export const linkedItemFromInbound = (inbound) =>
    buildLinkedItem(support_ticket_linked_type.INBOUND, inbound, inbound?.barcode, inbound?.reference);

export const linkedItemFromReturn = (ret) =>
    buildLinkedItem(support_ticket_linked_type.RETURN, ret, ret?.reference, ret?.createdAt);

export const linkedItemFromInvoice = (invoice) =>
    buildLinkedItem(support_ticket_linked_type.INVOICE, invoice, invoice?.number, invoice?.externalReference);

export const linkedItemFromProduct = (product) =>
    buildLinkedItem(support_ticket_linked_type.PRODUCT, product, product?.sku, product?.description);

export const linkedItemFromWebshopCredentials = (credentials) =>
    buildLinkedItem(
        support_ticket_linked_type.WEBSHOPCREDENTIALS,
        credentials,
        credentials?.description,
        credentials?.webshop_type ?? credentials?.webshopType
    );
